type Primitive = string | number | boolean | undefined | null;
export type FplDataAttributes = {
  [key: `data-${string}`]: Primitive;
};

export const getFplDataAttributes = (props: Record<string, unknown>) => {
  const dataAttributes: FplDataAttributes = {};

  for (const [key, value] of Object.entries(props)) {
    if (key.startsWith('data-')) {
      dataAttributes[key as keyof FplDataAttributes] = value as Primitive;
    }
  }

  return dataAttributes;
};
